<style lang="stylus" scoped>
@import './cardMap.stylus';

</style>

<template>
  <div class="home-main">
    <div class="map-search">
      <div class="map-title">
        <el-row>
          <CardHeader/>
        </el-row>
      </div>
      <map-data-table
        :areaList="areaList"
        v-if="areaList&&areaList.length>0"
        :changeCity="changeCity"
      ></map-data-table>
    </div>
    <div class="map-data">
      <div class="map-area">
        <home-map :city-data="cardData" :dataType="dataType" :title="title"></home-map>
      </div>
      <div class="map-card" id="city" style="top:0;height:210px;border:1px solid #ccc;"></div>
      <map-card :changeType="changeType" :cardItem="cardData"></map-card>
    </div>
  </div>
</template>

<script>
import homeMap from './components/map.vue'
import mapDataTable from './components/mapDataTable.1.vue'
import mapCard from './components/mapCard.vue'
import CardHeader from './components/cardHeader.vue'

import echarts from 'echarts'
import Cookies from 'js-cookie'

import shihua from './data/shihua.js'
import shiyou from './data/shiyou.js'
import other from './data/other.js'
import all from './data/all.js'
const allData = [shihua, shiyou, other]
let i = 0
export default {
  name: 'home',
  components: {
    homeMap,
    mapDataTable,
    mapCard,
    CardHeader
  },
  data() {
    return {
      areaList: [], //省列表
      dataType: '6', //点击省份详情列表
      title: 0, //地图标题
      mark: false, //是否显示遮罩层
      i: 0,
      allData: allData,
      cardData: allData[i].total,
      index: -1
    }
  },
  created() {
    //this.initData()
  },
  watch: {
    i: function(value, oldValue) {
      this.initData()
    },
    index: function(value, oldValue) {
      this.initData()
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    changeType({ num, title }) {
      this.dataType = num
      this.title = title
    },
    initData() {
      let that = this
      let city = echarts.init(document.getElementById('city'))
      let option = {
        title: {
          text: '车辆途经省'
          //subtext: '纯属虚构',
          //x: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 10,
          top: 100,
          bottom: 20,
          data: ['中国石化', '中国石油', '其他油站']
        },
        color: ['#FF9F7F','#37A2DA',  '#66E0E3'],
        series: [
          {
            name: '名称',
            type: 'pie',
            radius: '55%',
            center: ['40%', '50%'],
            data: all[this.index + 1].main,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      city.setOption(option)
      city.on('click', function(params) {
        that.i = params.dataIndex // 0 中国石油 1 中国石化 2 其他
        i = params.dataIndex
      })
      that.areaList = this.allData[this.i].list
      that.changeCity(this.index)
    },
    changeCity(index) {
      this.index = index
      if (index == -1) {
        this.cardData = allData[this.i].total
      } else {
        this.cardData = allData[this.i].list[index]
      }
    }
  }
}
</script>
